import { createApp } from 'vue';
import router from './router';
import VueMapboxTs from 'vue-mapbox-ts';
import App from './App.vue';
import type { UserModule } from './types';
import Pusher from 'pusher-js';
import './common/styles/main.css';
import { worker } from './mocks/browser';
import AbilityClient from './common/services/AbilityClient';
import '@quasar/quasar-ui-qcalendar/dist/index.css';
//import { QCalendar } from '@quasar/quasar-ui-qcalendar';

const app = createApp(App);
app.use(VueMapboxTs);
app.use(router);
app.use(AbilityClient);
//app.component('QCalendar', QCalendar);

// install all modules under `modules/`
Object.values(
  import.meta.glob<{ install: UserModule }>('./common/modules/*.ts', {
    eager: true,
  }),
).forEach((i) => i.install?.({ app }));

app.mount('#app');

if (
  import.meta.env.MODE !== 'production' &&
  import.meta.env.VITE_MOCKS_ENABLED === 'true'
) {
  worker.start({
    onUnhandledRequest(req: any, print: any) {
      if (
        req.url.pathname.startsWith('/src/common/styles/') ||
        req.url.pathname.startsWith('/node_modules/.pnpm/@quasar+extras')
      )
        return;

      print.warning();
    },
  });
}

if (import.meta.env.MODE !== 'production') {
  // Enable Pusher debug logging in development
  // Runtime config (window.APP_ENV) is checked first in all environments, with build-time fallback
  const pusherDebug = window.APP_ENV?.PUSHER_DEBUG || import.meta.env.VITE_PUSHER_DEBUG;
  Pusher.logToConsole = pusherDebug === 'true';
}
